module.exports = "b5f8055e81fbaced14a7ff8d3cbb2e6f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-star.png
// module id = 103
// module chunks = 0